export default {
  title: {
    base: 'As seen in',
  },
  cards: PRESS_CARDS,
};
